import React, { useState } from "react";
import { ChevronDown, ChevronUp, Compass } from "lucide-react";

/**
 * Collapsible "Start Here" onboarding panel for the homepage.
 * California-only — no multi-state references.
 */
export default function StartHerePanel() {
  const [open, setOpen] = useState(true);
  return (
    <section
      className="paper-card rounded-sm mb-5 overflow-hidden"
      data-testid="start-here-panel"
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center gap-2 px-4 sm:px-5 py-3 text-left hover:bg-[hsl(var(--paper-2))]"
        data-testid="start-here-toggle"
      >
        <Compass className="w-4 h-4 text-[hsl(var(--ink))]" />
        <span className="section-label">Start here</span>
        <span className="ml-auto text-[hsl(var(--ink-muted))]">
          {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
        </span>
      </button>
      {open && (
        <div className="px-4 sm:px-5 pb-4 pt-1 border-t border-dashed border-[hsl(var(--rule))]">
          <p className="text-sm text-[hsl(var(--ink-2))] leading-relaxed mb-3 max-w-3xl">
            Search a California bill or browse ballot measures. Measure X-Ray
            works best with official government source links. If a source can
            not be fetched, paste the full bill or measure text. After
            analysis, check the plain-English summary, Hidden Cost / Future
            Fee Watch, Public Claim Reality Check, citations, and final voter
            takeaway.
          </p>
          <ol className="grid grid-cols-1 sm:grid-cols-2 sm:grid-rows-3 sm:grid-flow-col gap-x-6 gap-y-2 text-sm text-[hsl(var(--ink-2))]">
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">1.</span>
              <span>Look up an Assembly or Senate bill by number (e.g., AB&nbsp;25, SB&nbsp;42).</span>
            </li>
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">2.</span>
              <span>Or browse the qualified / eligible California ballot measures.</span>
            </li>
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">3.</span>
              <span>Prefer official source URLs (LegInfo, Secretary of State, LAO).</span>
            </li>
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">4.</span>
              <span>If a source is blocked or scanned-only, paste the full text below.</span>
            </li>
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">5.</span>
              <span>Run analysis and read the report from top to bottom.</span>
            </li>
            <li className="flex gap-2">
              <span className="font-mono text-[hsl(var(--ink-muted))]">6.</span>
              <span>Paste any public claim into the Reality Check box to test it against the bill text.</span>
            </li>
          </ol>
          <div className="mt-4 text-xs text-[hsl(var(--ink-muted))] leading-relaxed">
            Measure X-Ray is free for voters. Optional support helps keep the
            tool running. Custom dossiers are paid deep-dive reports for
            journalists and policy folks — basic bill and measure analysis is
            never paywalled.
          </div>
        </div>
      )}
    </section>
  );
}
